import { IFlatStats } from '../../types/flatStats';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EGetFlatStatsActionType {
  Loading = 'flatStats/getFlatStats/loading',
  Succeed = 'flatStats/getFlatStats/succeed',
  Failed = 'flatStats/getFlatStats/failed',
}

export type TGetFlatStatsLoading = ITypedReduxAction<EGetFlatStatsActionType.Loading>;
export type TGetFlatStatsSucceed = ITypedReduxAction<EGetFlatStatsActionType.Succeed, IFlatStats>;
export type TGetFlatStatsFailed = ITypedReduxAction<EGetFlatStatsActionType.Failed, string>;

export type TFlatStatsActions = TGetFlatStatsLoading | TGetFlatStatsSucceed | TGetFlatStatsFailed;
